import React, { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import ComponentErrorBoundary from "./ComponentErrorBoundary";
import Overview from "./admin/Overview";
import UserManagement from "./admin/UserManagement";
import ClientManagement from "./admin/ClientManagement";
import "./AdminConsole.css";

const AdminConsole = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState("overview");
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalPresentations: 0,
    activeUsers: 0,
    systemHealth: "Healthy",
  });

  useEffect(() => {
    // Fetch admin statistics
    fetchAdminStats();
  }, []);

  const fetchAdminStats = async () => {
    // TODO: Implement API call to fetch admin statistics
    // For now, using placeholder data
    setStats({
      totalUsers: 5,
      totalPresentations: 6,
      activeUsers: "*",
      systemHealth: "Healthy",
    });
  };

  // Component rendering helper
  const renderActiveComponent = () => {
    switch (activeTab) {
      case "overview":
        return (
          <ComponentErrorBoundary componentName="Overview">
            <Overview stats={stats} />
          </ComponentErrorBoundary>
        );
      case "users":
        return <UserManagement />;
      case "clients":
        return (
          <ComponentErrorBoundary componentName="Client Management">
            <ClientManagement />
          </ComponentErrorBoundary>
        );
      default:
        return (
          <ComponentErrorBoundary componentName="Overview">
            <Overview stats={stats} />
          </ComponentErrorBoundary>
        );
    }
  };

  const tabs = [
    { id: "overview", label: "Overview", icon: "📊" },
    { id: "users", label: "User Management", icon: "👥" },
    { id: "clients", label: "Client Management", icon: "👤" },
  ];

  return (
    <div className="admin-console">
      <div className="admin-header">
        <div className="admin-title">
          <h1>Admin Console</h1>
          <p>
            Welcome back, {user?.name || user?.email?.split("@")[0] || "Admin"}
          </p>
        </div>
        <div className="admin-user-info">
          <span className="user-role">
            {user?.role === 3 ? "Super Administrator" : "Administrator"}
          </span>
        </div>
      </div>

      <div className="admin-navigation">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`nav-tab ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab.id)}>
            <span className="tab-icon">{tab.icon}</span>
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>

      <div className="admin-content">{renderActiveComponent()}</div>
    </div>
  );
};

export default AdminConsole;
